import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import Button from '@atlaskit/button/new';
import ModalDialog, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
export var ContentComponent = function ContentComponent(_ref) {
  var syncBlockStoreManager = _ref.syncBlockStoreManager;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var resolverRef = React.useRef(undefined);
  var handleClose = useCallback(function (confirm) {
    return function () {
      if (resolverRef.current) {
        resolverRef.current(confirm);
        resolverRef.current = undefined;
      }
      setIsOpen(false);
    };
  }, []);
  var confirmationCallback = useCallback(function () {
    setIsOpen(true);
    var confirmedPromise = new Promise(function (resolve) {
      resolverRef.current = resolve;
    });
    return confirmedPromise;
  }, []);
  useEffect(function () {
    var unregister = syncBlockStoreManager.registerConfirmationCallback(confirmationCallback);
    return function () {
      unregister();
    };
  }, [syncBlockStoreManager, confirmationCallback]);
  return /*#__PURE__*/React.createElement(ModalTransition, null, isOpen && /*#__PURE__*/React.createElement(ModalDialog, {
    onClose: handleClose(false)
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    hasCloseButton: true
  }, /*#__PURE__*/React.createElement(ModalTitle, null, "Confirmation")), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("div", null, "Are you sure you want to delete this synced block?")), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: handleClose(false)
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    appearance: "danger",
    onClick: handleClose(true),
    autoFocus: true
  }, "Delete"))));
};